module.exports = __webpack_public_path__ + "static/media/Ornate2_After.d53f2775.jpg";